<template>
  <aside
      id="sidenav-main"
      class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-3 fixed-start ms-3 bg-gradient-green"
  >
    <div class="sidenav-header bg-gradient-success">
      <i
          id="iconSidenav"
          class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
          aria-hidden="true"
      ></i>
      <router-link class="m-0 p-0" :to="{ name: 'Dashboard' }">
        <img
            src="@/assets/img/logo1.jpeg"
            class="h-100 w-100" style="object-fit: cover;"
            alt="main_logo"
        />
      </router-link>
    </div>
    <sidenav-list/>
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";

export default {
  name: "Index",
  components: {
    SidenavList,
  },
};
</script>
<style scoped>
.bg-gradient-green {
  background-color: #022126;
}
</style>
